import { getNode, isCustomNodeAllowed, setActiveTool } from "../../../commands/custom-commands";
import { deleteRow, addRowBefore, addRowAfter } from "prosemirror-tables";
import { customSchema } from "../../../schemas/custom-schema";

export default class TableRowsTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container has-disabled--hidden";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName ="--table-rows-anchor";
    this.buttonElement.dataset.action = "table-rows";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Filas";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Filas";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Filas";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--table-rows-anchor";
    this.addBeforeButton = document.createElement("button");
    this.addBeforeButton.setAttribute("type", "button");
    this.addBeforeButton.className = "editor-button";
    this.addBeforeButton.textContent = "Añadir arriba";

    this.addAfterButton = document.createElement("button");
    this.addAfterButton.setAttribute("type", "button");
    this.addAfterButton.className = "editor-button";
    this.addAfterButton.textContent = "Añadir abajo";

    this.removeButton = document.createElement("button");
    this.removeButton.type = "button";
    this.removeButton.className = "editor-button";
    this.removeButton.textContent = "Remover";

    this.dialogElement.appendChild(this.addBeforeButton);
    this.dialogElement.appendChild(this.addAfterButton);
    this.dialogElement.appendChild(this.removeButton);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.removeAction = this.removeButtonClickCallback();
    this.addBeforeAction = this.addBeforeButtonClickCallback();
    this.addAfterAction = this.addAfterButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.addBeforeButton.addEventListener("click", this.addBeforeAction);
    this.addAfterButton.addEventListener("click", this.addAfterAction);
    this.removeButton.addEventListener("click", this.removeAction);
  }

  update(view) {
    const node = getNode(view.state, customSchema.nodes.table);
    if(!!node) {
      this.buttonElement.removeAttribute("disabled");
      this.addBeforeButton.removeAttribute("disabled");
      this.addAfterButton.removeAttribute("disabled");
      this.removeButton.removeAttribute("disabled");
    } else {
      this.buttonElement.setAttribute("disabled", "");
      this.addBeforeButton.setAttribute("disabled", "");
      this.addAfterButton.setAttribute("disabled", "");
      this.removeButton.setAttribute("disabled", "");
    }
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.removeButton.removeEventListener("click", this.removeAction);
    this.addBeforeButton.removeEventListener("submit", this.addBeforeAction);
    this.addAfterButton.removeEventListener("submit", this.addAfterAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.addBeforeButton = null;
    this.addAfterButton = null;
    this.removeButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.addBeforeAction = null;
    this.addAfterAction = null;
    this.removeAction = null;
  }

  removeButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }

      deleteRow(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  addBeforeButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }

      addRowBefore(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  addAfterButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }

      addRowAfter(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}